import { render, staticRenderFns } from "./ssoLogin.vue?vue&type=template&id=23942126&scoped=true&"
import script from "./ssoLogin.vue?vue&type=script&lang=js&"
export * from "./ssoLogin.vue?vue&type=script&lang=js&"
import style0 from "./ssoLogin.vue?vue&type=style&index=0&id=23942126&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23942126",
  null
  
)

export default component.exports